var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ontice-box"},[_c('p',{staticClass:"title"},[_vm._v("温馨提示")]),_c('p',{staticClass:"content"},[_vm._v(" 1、节日福利选品每人700¥，超出不可提交订单：最低订单金额不得少于698¥。 "),_c('br'),_c('br'),_vm._v(" 2、配送地址仅限广州市内，超出范围无法填写地址 ")])])
}]

export { render, staticRenderFns }